import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import InlineEdit from '../common/InlineEdit/InlineEdit';
import { toastWarning } from '../../util/toastUtils';
import { createWarningMessageObj } from '../../util/preferenceUtils';
import {
  SAVE_LIST_EMPTY_ITEM_WARNING,
  SC_SAVE_LIST_CONFIRMATION_MSG,
  SC_SAVE_MODIFIED_PACKAGE_LIST,
  SAVE_SC_SUBENTITIES_LIST_LENGTH_WARNING,
} from '../../messages/messages';
import Modal from '../common/Modal/Modal';
import GenericButton from '../common/GenericButton';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import { PREFERENCE_SALES_CATALYST, PREFERENCE_SALES_CATALYST_SUBENTITIES,
  PREFERENCE_SALES_CATALYST_SAVE_SE_LIST, SALES_CATALYST,
  PREFERENCE_STUDY, SC_PACKAGE } from '../../constants';

const scSubEntitiesKey = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_SUBENTITIES}`;
const scDefaultStudy = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_STUDY}`;
const scSubEntitiesSvlKey = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_SAVE_SE_LIST}`;
const modalWarningStyle = {
  width: '40%',
  height: '40px',
  left: '25%',
  top: '25%',
};

class PreferencesCommonInlineEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listUpdate: {
        callBackReference: undefined,
        listTempVal: undefined,
        saveAsNew: false,
      },
    };
  }

  getKeyData = key => {
    const { modifiedPreferences } = this.props;
    const keys = key.split('.');
    return !_.isEmpty(modifiedPreferences) ?
    modifiedPreferences[keys[0]][keys[1]] : undefined;
  }

  saveData = (value, callbackFn) => {
    const { field } = this.props;
    const dataElContent = this.getKeyData(field.dataElKey);
    const updateElContent = this.getKeyData(field.updateKey);
    if (dataElContent !== undefined && !dataElContent.length > 0) {
      callbackFn(false);
      toastWarning(SAVE_LIST_EMPTY_ITEM_WARNING);
      return;
    }
    if (updateElContent && !_.isEmpty(updateElContent) && updateElContent.value !== 0) {
      this.setState(prevState => ({
        listUpdate: {
          ...prevState.listUpdate,
          callBackReference: callbackFn,
          listTempVal: value,
        },
      }));
      this.modalWarning.show();
    } else {
      this.setState(prevState => ({
        listUpdate: {
          ...prevState.listUpdate,
          callBackReference: undefined,
        },
      }), () => {
        this.saveSubEntitiesListAction(0, value, callbackFn);
      });
    }
  }

  getKeyDataVal = (key, defaultData, newData) => {
    const { modifiedPreferences, userPreference } = this.props;
    const keys = key.split('.');
    let dataKey;
    if (newData !== undefined) {
      dataKey = newData;
    } else {
      dataKey = defaultData ? userPreference : modifiedPreferences;
    }
    return !_.isEmpty(dataKey) ? dataKey[keys[0]][keys[1]] : undefined;
  }

  getStudyInfo = () => {
    const { field, scStudies, studies, bcStudies } = this.props;
    if (field.menuName === 'SalesCatalyst') {
      const getStudyInfo = this.getKeyDataVal(scDefaultStudy);
      return getStudyInfo === -1 ? scStudies[0].sl[0].pn : getStudyInfo;
    }
    if (field.menuName === 'BrandCatalyst') {
      const getStudyInfo = this.getKeyDataVal(bcDefaultStudy);
      return getStudyInfo === -1 ? bcStudies[0].sl[0].pn : getStudyInfo;
    }
    return studies[0].sl[0].pn;
  }

  saveSubEntitiesListAction = (listId, ListName, callBack) => {
    const { field, defaultSection } = this.props;
    const dataElContent = this.getKeyData(field.dataElKey);
    const data = {};
    data.templateId = listId;
    data.templateName = ListName;
    data.subEntities = _.map(dataElContent, o => ({
      label: o.label,
      expression: o.expression,
    }));
    const saveListParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.getStudyInfo(),
      data,
      type: 'subentities',
    };
    this.props.salesCatalystActions.saveSCTemplate(saveListParams).then(response => {
      if (response) {
        callBack(true);
        this.updatePreferences(
          {
            label: response.templateName,
            value: response.templateId,
          },
          field.updateKey,
        );
        if (defaultSection && defaultSection === _.toLower(SC_PACKAGE) && field.dbKey === '_sc._svl') {
          this.updatePreferences(
            response.templateName,
            field.dbKey,
          );
        }
        this.setWarningMessage(1);
      } else {
        callBack(false);
      }
    });
  }


  updateListBtnAction = type => {
    const { field } = this.props;
    const listUpdate = this.state.listUpdate;
    if (type === 'update' || type === 'saveNew') {
      this.setState((prevState) => ({
        listUpdate: {
          ...prevState.listUpdate,
          callBackReference: undefined,
          saveAsNew: false,
        },
      }));
      this.modalWarning.hide();
      this.saveSubEntitiesListAction(type === 'saveNew' ?
        0 : this.getKeyData(field.updateKey).value, listUpdate.listTempVal, listUpdate.callBackReference);
    } else if (type === 'saveAsNew') {
      this.setState(prevState => ({
        listUpdate: {
          ...prevState.listUpdate,
          saveAsNew: true,
          listTempVal: undefined,
        },
      }));
    }
  }

  updateTemplateModalClose = () => {
    if (this.state.listUpdate.callBackReference !== undefined) {
      this.state.listUpdate.callBackReference(true);
      this.setState((prevState) => ({
        listUpdate: {
          ...prevState.listUpdate,
          callBackReference: undefined,
          saveAsNew: false,
        },
      }));
    }
  }

  validateFn = (value, callback) => {
    const { field } = this.props;
    let callBackArg = true;
    if (field.labelLength !== undefined && value.length > field.labelLength) {
      callBackArg = false;
    } else {
      callBackArg = true;
    }
    callback(
      callBackArg,
      callBackArg ? '' : SAVE_SC_SUBENTITIES_LIST_LENGTH_WARNING,
    );
  };

  updatePreferences = (node, key) => {
    const { dbKey } = this.props.field;
    this.props.updatePreferences(
      key !== undefined ? key : dbKey,
      node
    );
  }

  setWarningMessage = type => {
    const { field } = this.props;
    if (field.dbKey === scSubEntitiesSvlKey) {
      const warningData = createWarningMessageObj(
        'SalesCatalyst', scSubEntitiesKey, SALES_CATALYST, SC_SAVE_MODIFIED_PACKAGE_LIST, type);
      this.props.setPreferenceWarning(warningData);
    }
  }

  render() {
    const { field, defaultSection } = this.props;
    const { listUpdate } = this.state;
    return (
      <div>
        <Modal
          title=""
          ref={node => {this.modalWarning = node;
            return this.modalWarning}}
          dialogStyles={modalWarningStyle}
          afterClose={() => this.updateTemplateModalClose()}
        >
          <div className="text-center">
            <div>
              <p>{SC_SAVE_LIST_CONFIRMATION_MSG}</p>
              {!listUpdate.saveAsNew && <div>
                <GenericButton
                  btnStyle="button"
                  name="Update"
                  onBtnClick={() => this.updateListBtnAction('update')}
                />
                <GenericButton
                  btnStyle="button btn-cncl"
                  name="Save As New"
                  onBtnClick={() => this.updateListBtnAction(`${
                    this.getKeyData(field.updateKey).label === listUpdate.listTempVal ? 'saveAsNew' : 'saveNew'
                    }`)}
                />
              </div>}
              {listUpdate.saveAsNew && <div>
                <input
                  type="text"
                  ref={node => {this.newTemplateNameFiled = node;
                    return this.newTemplateNameFiled}}
                  placeholder="Enter New List Name"
                  className="summary-input-box"
                  onChange={() => this.setState({
                    listUpdate: {
                      ...listUpdate,
                      listTempVal: this.newTemplateNameFiled.value,
                    },
                  })}
                />
                <div className="margin-top-10">
                  <GenericButton
                    btnStyle="button"
                    name="Save"
                    onBtnClick={() =>
                      (listUpdate.listTempVal !== undefined &&
                        listUpdate.listTempVal.length > 0) ?
                        this.updateListBtnAction('saveNew') : {}
                    }
                  />
                  <GenericButton
                    btnStyle="button btn-cncl"
                    name="Cancel"
                    onBtnClick={() => this.modalWarning.hide()}
                  />
                </div>
              </div>}
            </div>
          </div>
        </Modal>
        <InlineEdit
          textVal={field.defaultValue !== '' ? field.defaultValue : ''}
          editBlockWidth="100%"
          updateFn={this.saveData}
          validateFn={this.validateFn}
          editMode={field.editMode ? 'on' : undefined}
          placeholder={field.inputPlaceholder !== '' ? field.inputPlaceholder : ''}
          editViewClass={field.inputClass !== '' ? field.inputClass : ''}
          disabled={`${this.getKeyData(field.dataElKey) !== undefined && 
            this.getKeyData(field.dataElKey).length === 0 ? 'disabled' : ''}`}
          defaultSection={defaultSection}
        />
      </div>
    );
  }
}

PreferencesCommonInlineEdit.propTypes = {
  field: PropTypes.shape({
    menuName: PropTypes.string,
    style: PropTypes.shape({}),
    defaultValue: PropTypes.string,
    dbKey: PropTypes.string,
    updateKey: PropTypes.string,
    dataElKey: PropTypes.string,
    inputClass: PropTypes.string,
    inputPlaceholder: PropTypes.string,
    labelLength: PropTypes.number,
    editMode: PropTypes.bool,
  }),
  scStudies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  bcStudies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  studies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  salesCatalystActions: PropTypes.shape({
    saveSCTemplate:PropTypes.func
  }),  
  updatePreferences: PropTypes.func,
  setPreferenceWarning: PropTypes.func,
  modifiedPreferences: PropTypes.shape({}),
  defaultSection: PropTypes.string,
  activeAccountId:PropTypes.number,
  userPreference: PropTypes.shape({}),
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    userPreference: state.preferences.userPreferences,
    scStudies: state.study.salesCatalystStudies,
    salesCatalystData: state.salesCatalyst,
    bcStudies: state.study.insight360studies,
    studies: state.study.studies,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(PreferencesCommonInlineEdit);
